export default "__VITE_ASSET__BtMdENNV__"